export interface Testimonial {
  name: string;
  location: string;
  rating: number;
  text: string;
  date: string;
  /** ISO date used for schema.org datePublished. */
  publishedAt: string;
}

/**
 * Verified client reviews. Keep `text`, `name`, and `rating` identical to what
 * is displayed on the page — schema.org review markup must mirror the visible
 * testimonial exactly.
 */
export const testimonials: Testimonial[] = [
  {
    name: "Melissa S.",
    location: "Verified Google Review",
    rating: 5,
    text: "Ben and his crew are the best of the best! He pays attention to detail and is extremely thorough. He goes over and beyond without hesitation. If you need water mitigation/restoration Ben is your guy!",
    date: "Recent",
    publishedAt: "2025-11-04",
  },
  {
    name: "Sarah T.",
    location: "Seguin, TX",
    rating: 5,
    text: "WTR Restoration arrived in less than an hour when our bathroom flooded. They handled everything with the insurance company. Highly recommend!",
    date: "2 weeks ago",
    publishedAt: "2025-10-21",
  },
  {
    name: "Henry L.",
    location: "Canyon Lake, TX",
    rating: 5,
    text: "Ben and his crew took care of our Canyon Lake home after a toilet overflow. The rebuild looked even better than before the damage.",
    date: "1 month ago",
    publishedAt: "2025-09-30",
  },
  {
    name: "John M.",
    location: "New Braunfels, TX",
    rating: 5,
    text: "They explained every step, set up drying equipment, and worked directly with our adjuster. Outstanding service.",
    date: "3 weeks ago",
    publishedAt: "2025-10-14",
  },
  {
    name: "Lisa R.",
    location: "San Marcos, TX",
    rating: 5,
    text: "Fast response time and professional work. Ben's expertise with insurance claims saved us thousands. Would use them again without hesitation.",
    date: "1 week ago",
    publishedAt: "2025-10-28",
  },
  {
    name: "Michael P.",
    location: "New Braunfels, TX",
    rating: 5,
    text: "After our kitchen flooded, WTR was on-site within 45 minutes. Their thermal imaging found hidden moisture we didn't know about. True professionals.",
    date: "2 months ago",
    publishedAt: "2025-09-02",
  },
  {
    name: "Jennifer K.",
    location: "Gruene, TX",
    rating: 5,
    text: "White glove service from start to finish. They treated our home like it was their own. Ben personally walked us through the entire process.",
    date: "3 weeks ago",
    publishedAt: "2025-10-14",
  },
];

/** Total verified five-star reviews across Google, BBB and HomeAdvisor. */
export const REVIEW_COUNT = 50;
export const AVERAGE_RATING = 5.0;

const BUSINESS_ID = "https://wtrrestoration.com/#business";

/**
 * LocalBusiness node carrying aggregateRating plus one Review node per visible
 * testimonial, ready to drop into a page's structuredData @graph.
 */
export const buildReviewSchema = () => ({
  "@type": "LocalBusiness",
  "@id": BUSINESS_ID,
  name: "WTR Restoration",
  url: "https://wtrrestoration.com/",
  telephone: "+1-830-360-2600",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: AVERAGE_RATING.toFixed(1),
    reviewCount: REVIEW_COUNT,
    bestRating: "5",
    worstRating: "1",
  },
  review: testimonials.map((t) => ({
    "@type": "Review",
    author: { "@type": "Person", name: t.name },
    datePublished: t.publishedAt,
    reviewBody: t.text,
    reviewRating: {
      "@type": "Rating",
      ratingValue: String(t.rating),
      bestRating: "5",
      worstRating: "1",
    },
    itemReviewed: { "@id": BUSINESS_ID },
  })),
});
